import {AxiosResponse} from "axios";
import {UI} from "../ui/UI";

import * as Debug from 'debug';
import {IRecipientRecord, RecipientRecordHelper} from "platform_common/types/data/RecipientRecord";
import {CAPIExternalRecipient} from "./api/CAPIExternalRecipient";
import {
    JAPIExternalRecipientGetRecordByAuthCodeResponse,
    JAPIExternalRecipientGetRecordByEmailResponse, JAPIExternalRecipientUpdateRecordPlayedResponse,
    JAPIExternalRecipientUpdateRecordRedeemedResponse
} from "platform_common/types/api/JAPIExternalRecipient";
import {PuzzleInfo} from "./PuzzleInfo";
import {EMode} from "./Mode";
import {Global} from "./Global";

let debug:Debug.IDebugger = Debug.debug('vgift.com:libs:RecipientInfo');

/**
 * Class to facilitate all interaction with recipient information in the app.
 */
export class RecipientInfo {


    /**
     * Get record from auth code and populate UI
     *
     * @param authCode
     */
    public static async getRecordFromAuthCodeAndPopulateUI(authCode:string):Promise<boolean> {

        // get record by auth code
        let getRecordResult:AxiosResponse<JAPIExternalRecipientGetRecordByAuthCodeResponse> = await CAPIExternalRecipient.getRecordByAuthCode(authCode) as any;

        // if record found from auth code
        if (getRecordResult.data.found == true) {

            let initialRecord:IRecipientRecord = RecipientRecordHelper.JToI(getRecordResult.data.record);

            // if no puzzle yet assigned
            if (initialRecord.puzzleId == null) {

                // have puzzle set randomly
                await CAPIExternalRecipient.updateRecordSetPuzzle(initialRecord.id);

                // get record again
                getRecordResult = await CAPIExternalRecipient.getRecordByAuthCode(authCode) as any
            }

            let rRecord:IRecipientRecord = RecipientRecordHelper.JToI(getRecordResult.data.record);

            // set recipient record in UI
            UI.R_STORE.setRecipientRecord(rRecord);

            // get puzzle record
            if (rRecord.puzzleId != null) {
                await PuzzleInfo.getRecordAndPopulate(rRecord.puzzleId)
            }

            // consider puzzle as new viewed
            await CAPIExternalRecipient.updateRecordViewed(rRecord.id);

            return true;
        }
        else {
            return false;
        }

    }

    /**
     * Get record from email and populate UI
     *
     * @param email
     */
    public static async getRecordFromEmailAndPopulateUI(email:string):Promise<boolean> {

        // get record by email
        let getRecordResult:AxiosResponse<JAPIExternalRecipientGetRecordByEmailResponse> = await CAPIExternalRecipient.getRecordByEmail(email) as any;

        // if record found from auth code
        if (getRecordResult.data.found == true) {

            let initialRecord:IRecipientRecord = RecipientRecordHelper.JToI(getRecordResult.data.record);

            // if no puzzle yet assigned
            if (initialRecord.puzzleId == null) {

                // have puzzle set randomly
                await CAPIExternalRecipient.updateRecordSetPuzzle(initialRecord.id);

                // get record again
                getRecordResult = await CAPIExternalRecipient.getRecordByEmail(email) as any;
            }

            let rRecord:IRecipientRecord = RecipientRecordHelper.JToI(getRecordResult.data.record);

            // set recipient record in UI
            UI.R_STORE.setRecipientRecord(rRecord);

            // get puzzle record
            if (rRecord.puzzleId != null) {
                await PuzzleInfo.getRecordAndPopulate(rRecord.puzzleId)
            }

            // consider puzzle as new viewed
            await CAPIExternalRecipient.updateRecordViewed(rRecord.id);

            return true;
        }
        else {
            return false;
        }
    }

    /**
     * Updated record as played
     *
     * @param id
     * @param secondsPlayed
     * @param puzzleSavePoint
     */
    public static async updateRecordAsPlayed(id:number, secondsPlayed:number, puzzleSavePoint:string):Promise<boolean> {

        // get record by email
        let updateRecordResult:AxiosResponse<JAPIExternalRecipientUpdateRecordPlayedResponse> = await CAPIExternalRecipient.updateRecordPlayed(id, secondsPlayed, puzzleSavePoint) as any;

        // if record modified
        if (updateRecordResult.data.modified == true) {
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * Updated record as redeemed
     *
     * @param id
     */
    public static async updateRecordAsRedeemed(id:number):Promise<boolean> {

        // get record by email
        let updateRecordResult:AxiosResponse<JAPIExternalRecipientUpdateRecordRedeemedResponse> = await CAPIExternalRecipient.updateRecordRedeemed(id) as any;

        // if record modified
        if (updateRecordResult.data.modified == true) {
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * build test record and populate UI
     */
    public static buildTestAndPopulateUI():void {

        // set system in test test mode
        Global.mode = EMode.Testing;

        let rRecord:IRecipientRecord = <any>{
            id: 0, // fake id
            name: "Admin User",
            email: "admin@vgift.com",
            puzzleSavePoint: null // must be null as that is what is expected

        };

        // set recipient record in UI
        UI.R_STORE.setRecipientRecord(rRecord);

    }

}
